import { LoginResult } from 'types'

export const LOGIN_RESULT = 'LOGIN_RESULT'
export const LOGOUT = 'LOGOUT'
export const UPDATE_IDENTIFIER = 'UPDATE_IDENTIFIER'

export interface LoginResultPayload {
  loginResult: LoginResult
}

interface LoginAction {
  type: typeof LOGIN_RESULT
  payload: LoginResultPayload
}

interface LogoutAction {
  type: typeof LOGOUT
  payload: boolean
}

interface UpdateIdentifierAction {
  type: typeof UPDATE_IDENTIFIER
  payload: string
}

export type CustomerActionTypes = LoginAction | LogoutAction | UpdateIdentifierAction
